import type { StartPayEventHandler, StartPayEventMap, StartPayEventName } from "../types/events";

export const createEventEmitter = () => {
  const listeners = new Map<StartPayEventName, Set<StartPayEventHandler>>();

  return {
    on<T extends StartPayEventName>(event: T, handler: StartPayEventHandler<T>) {
      const eventListeners = listeners.get(event) ?? new Set();
      eventListeners.add(handler as StartPayEventHandler);
      listeners.set(event, eventListeners);
      return () => this.off(event, handler);
    },
    off<T extends StartPayEventName>(event: T, handler: StartPayEventHandler<T>) {
      listeners.get(event)?.delete(handler as StartPayEventHandler);
    },
    emit<T extends StartPayEventName>(event: T, payload: StartPayEventMap[T]) {
      listeners.get(event)?.forEach((handler) => handler(payload));
    },
    clear() {
      listeners.clear();
    }
  };
};
